import { render } from "./CampaignsPageUsb.vue?vue&type=template&id=3ef2961c&lang=html"
import script from "./CampaignsPageUsb.vue?vue&type=script&lang=js"
export * from "./CampaignsPageUsb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__